<ds-info-unavailable *ngIf="!isPositiveSystemStatus" [orderUnavailableHeader]="getOrderUnavailableHeader()"
  [orderUnavailableBody]="getOrderUnavailableBody()"></ds-info-unavailable>

<ds-order-system-status-info *ngIf="isPositiveSystemStatus" [pickupHeading]="pickupHeading" [pickupDate]="pickupDate"
  [statusInfoHeader]="statusInfoHeader" [statusInfoText]="statusInfoText"></ds-order-system-status-info>